const maxMessageLength = 2000;
export default maxMessageLength;
